import React, { useState } from "react";
import {
  blackColor,
  blackShade05,
  blackShade19,
  blueColor04,
  border25,
  borderTextBoxColor,
  greyColor42,
  greyColor47,
  lightRedColor,
  mobilePrimary,
  redColor,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import { YES_NO_DROPDOWN_DATA } from "../../../utils/data";
import TabelCellInputBox from "../../../components/TableInputs/TabelCellInputBox";
import TableCellDropdownBox from "../../../components/TableInputs/TableCellDropdownBox";
import DeleteIcon from "@mui/icons-material/Delete";
import { textOneLines } from "../../../utils/styles";
import {
  Box,
  Button,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { toTitleCase } from "../../../utils/validationUtils";
import ModalCard from "../../../components/ModalCard";

function VaraintProductPreview({ variantData, header }) {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  return (
    <Box sx={styles.card}>
      <Typography sx={styles.title}>Variance Details</Typography>
      <Box sx={styles.tableWrapper}>
        <TableContainer sx={styles.tableContainer} component={Box}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow
                sx={{
                  position: "sticky !important",
                  top: 0,
                  backgroundColor: greyColor42,
                  zIndex: 20,
                  borderRadius: "8px 8px 0 0",
                }}
              >
                {header?.map((item, index) => {
                  return (
                    <TableCell
                      key={item.id}
                      sx={
                        matches
                          ? {
                              ...styles.tableCell,
                              ...styles.colSticky(
                                variantData?.[0]?.variant2,
                                variantData?.[0]?.variant3
                              ),
                            }
                          : styles.tableCell
                      }
                    >
                      <Box
                        display={index === 0 ? "flex" : "inline-block"}
                        alignItems="center"
                        gap={1.2}
                      >
                        <Box sx={{ fontSize: 12, textTransform: "uppercase" }}>
                          {item?.title?.replace(/_/g, " ")}
                        </Box>
                      </Box>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody sx={{ backgroundColor: whiteColor }}>
              {variantData?.map((data, index) => (
                <TableRow
                  key={index}
                  sx={{
                    borderBottom: `1px solid ${borderTextBoxColor}`,
                    verticalAlign: "top",
                  }}
                >
                  <TableCell
                    sx={
                      matches
                        ? styles.tableStickyLeftCell
                        : styles.tableBodyCell
                    }
                  >
                    <TableInputPreview
                      data={
                        data?.variant1?.type === "codeValue"
                          ? toTitleCase(data?.variant1?.inputValue)
                          : data?.variant1?.inputValue
                      }
                    />
                  </TableCell>
                  {data?.variant2 && (
                    <TableCell
                      sx={
                        matches
                          ? styles.tableStickyLeft1Cell
                          : styles.tableBodyCell
                      }
                    >
                      <TableInputPreview
                        data={
                          data?.variant2?.type === "codeValue"
                            ? toTitleCase(data?.variant2?.inputValue)
                            : data?.variant2?.inputValue
                        }
                      />
                    </TableCell>
                  )}
                  {data?.variant3 && (
                    <TableCell
                      sx={
                        matches
                          ? styles.tableStickyLeft2Cell
                          : styles.tableBodyCell
                      }
                    >
                      <TableInputPreview
                        data={
                          data?.variant3?.type === "codeValue"
                            ? toTitleCase(data?.variant3?.inputValue)
                            : data?.variant3?.inputValue
                        }
                      />
                    </TableCell>
                  )}

                  <TableCell
                    sx={{ ...styles.tableBodyCell, minWidth: "200px" }}
                  >
                    <TableInputPreview data={data?.description} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableInputPreview data={data?.skuId} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableInputPreview data={data?.gstPercentage} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableInputPreview data={data?.productCodeKey} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableInputPreview data={data?.productCodeValue} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableInputPreview data={data?.originalPrice} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableInputPreview data={data?.offerPrice} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableImagePreview data={data?.photo1} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableImagePreview data={data?.photo2} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableImagePreview data={data?.photo3} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableImagePreview data={data?.photo4} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableInputPreview data={data?.productWeight} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableInputPreview data={data?.netProductWeight} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableInputPreview data={data?.productLength} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableInputPreview data={data?.productHeight} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableInputPreview data={data?.productWidth} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableInputPreview data={data?.qty} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableInputPreview data={data?.alertQty} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableInputPreview data={data?.minQty} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableInputPreview data={data?.maxQty} />
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <TableInputPreview data={data?.main ? "Yes" : "No"} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}

export default VaraintProductPreview;

const TableInputPreview = ({ data }) => {
  return (
    <Typography
      variant="body1"
      title={data}
      sx={{ ...styles.prodNameBox, ...textOneLines }}
    >
      {data || "-"}
    </Typography>
  );
};
const TableImagePreview = ({ data }) => {
  const [zoom, setZoom] = useState(false);
  return (
    <>
      {data ? (
        <Box
          component={"img"}
          src={data}
          sx={{
            width: "35px",
            height: "35px",
            border: border25,
            borderRadius: "7px",
          }}
          onClick={() => setZoom(true)}
        />
      ) : (
        <TableInputPreview data="" />
      )}

      <ModalCard
        open={zoom}
        handleClose={() => {
          setZoom(false);
        }}
        width="25%"
      >
        <Box sx={{ p: 3, backgroundColor: whiteColor, borderRadius: "10px" }}>
          <Typography
            variant="body1"
            fontSize={15}
            fontWeight={500}
            color={blackColor}
            mb={2}
          >
            Product Photo
          </Typography>
          <Box
            component={"img"}
            src={data}
            sx={{
              width: "100%",
              height: "auto",
              border: border25,
              borderRadius: "7px",
            }}
          />

          <Stack alignItems="center">
            <Button
              variant="contained"
              disableElevation
              sx={styles.applyBtn}
              onClick={() => setZoom(false)}
            >
              DONE
            </Button>
          </Stack>
        </Box>
      </ModalCard>
    </>
  );
};

const styles = {
  card: {
    backgroundColor: whiteColor,
    borderRadius: "13px",
    border: border25,
    boxShadow: "0 3px 4px rgb(229 233 240 / 22%)",
    p: "15px 15px 15px",
    mb: 2,
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: "20px",
    mb: "10px",
    color: blackShade19,
  },
  tableWrapper: {
    width: { md: "calc(100vw - 310px)", xs: "100%" },
    borderRadius: "8px",
    border: `1px solid ${borderTextBoxColor}`,
  },

  tableContainer: {
    borderRadius: "8px",
    overflow: "scroll",
    maxHeight: "calc(100vh - 370px)",
    maxWidth: "100%",
    "&::-webkit-scrollbar": {
      width: "4px",
      height: "4px",
      borderRadius: "50px !important",
    },
    "&::-webkit-scrollbar-thumb": {
      // background: '#d0d3da',
      background: "rgba(0,0,0,0.1)",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(0,0,0,0.05)",
    },
  },

  tableCell: {
    color: greyColor47,
    fontSize: "12.5px",
    fontWeight: "500",
    whiteSpace: "nowrap",
    padding: "8px 15px",
    backgroundColor: greyColor42,
    borderRight: `1px solid ${whiteColor}`,
  },

  colSticky: (sticky1, sticky2) => ({
    ":first-child": { position: "sticky", left: "0px", minWidth: "150px" },
    ":nth-child(2)": sticky1
      ? {
          position: "sticky",
          left: "150px",
          boxShadow: `-1px 0 0 0 ${whiteColor} inset ,1px 0 0 0 ${whiteColor} inset`,
        }
      : "",
    ":nth-child(3)": sticky2
      ? {
          position: "sticky",
          left: "300px",
          boxShadow: `-1px 0 0 0 ${whiteColor} inset ,1px 0 0 0 ${whiteColor} inset`,
        }
      : "",
  }),

  tableBodyCell: {
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    color: blackShade05,
    backgroundColor: whiteColor,
    padding: "8px 15px !important",
    borderRight: `1px solid ${borderTextBoxColor}`,
  },

  tableStickyLeftCell: {
    width: "150px !important",
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    color: blackShade05,
    backgroundColor: whiteColor,
    padding: "10px 15px !important",
    position: "sticky",
    left: 0,
    zIndex: 10,
    boxShadow: `-1px 0 0 0 ${borderTextBoxColor} inset`,
  },
  tableStickyLeft1Cell: {
    width: "150px !important",
    minWidth: "150px !important",
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    color: blackShade05,
    backgroundColor: whiteColor,
    padding: "10px 15px !important",
    position: "sticky",
    left: "150px",
    zIndex: 10,
    boxShadow: `-1px 0 0 0 ${borderTextBoxColor} inset ,1px 0 0 0 ${borderTextBoxColor} inset`,
  },
  tableStickyLeft2Cell: {
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    color: blackShade05,
    backgroundColor: whiteColor,
    padding: "10px 15px !important",
    position: "sticky",
    left: "300px",
    zIndex: 10,
    boxShadow: `-1px 0 0 0 ${borderTextBoxColor} inset ,1px 0 0 0 ${borderTextBoxColor} inset`,
  },

  prodNameBox: {
    whiteSpace: "normal",
    fontSize: 12,
    fontWeight: 600,
    color: blackShade19,
    lineHeight: "16px",
  },

  applyBtn: {
    fontSize: 13,
    fontWeight: 500,
    backgroundColor: { md: blueColor04, xs: mobilePrimary },
    border: `1.5px solid ${{ md: blueColor04, xs: mobilePrimary }}`,
    color: whiteColor,
    p: "4px 30px",
    mt: 2,
    "&:hover": {
      color: { md: blueColor04, xs: mobilePrimary },
      backgroundColor: whiteColor,
    },
  },
};
